import React, { useMemo } from 'react'
import { getDate, getDay } from 'date-fns'
import styled from 'styled-components'

import Icon from 'components/Icon'
import Text from 'components/Text'

import { size } from 'utils/responsive'

type Props = {
  date: Date
  isMarked?: boolean
  isSelected?: boolean
  onClick?: () => void
}

const DateItem: React.FC<Props> = ({ date, isMarked, isSelected, onClick }) => {
  const dayOfWeek = useMemo(() => {
    switch (getDay(date)) {
      case 0:
        return 'sun_short_lbl'
      case 1:
        return 'monday_short_lbl'
      case 2:
        return 'tuesday_short_lbl'
      case 3:
        return 'wednesday_short_lbl'
      case 4:
        return 'thursday_short_lbl'
      case 5:
        return 'friday_short_lbl'
      case 6:
        return 'saturday_short_lbl'
      default:
        return ''
    }
  }, [date])
  const dayOfMonth = useMemo(() => getDate(date), [date])

  return (
    <Container isSelected={Boolean(isSelected)} onClick={onClick}>
      {isMarked && <Marker color="red" fontSize={1} icon="circle" mb="5px" />}
      <Text color="gray5" fontSize={13} lineHeight="16px" mt={isMarked ? undefined : 13}>
        {dayOfWeek}
      </Text>
      <Text fontSize={16} fontWeight="bold" lineHeight="24px">
        {dayOfMonth}
      </Text>
    </Container>
  )
}

const Container = styled.div<{ isSelected: boolean }>`
  align-items: center;
  border-bottom: 3px solid ${(p) => (p.isSelected ? p.theme.colors.blue1 : 'transparent')};
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 2px 0;
  padding: 4px 8px;
  user-select: none;

  &:hover {
    background-color: ${(p) => p.theme.colors.gray1};
    color: ${(p) => p.theme.colors.blue2};
  }

  @media only screen and (max-width: ${size.medium}px) {
    padding: 4px 6px;
  }
`

const Marker = styled(Icon)`
  font-size: 7px;
`

export default DateItem
